class OOFilter {
    constructor () {
        this.datatablesContainer = document.querySelector('.datatables-container');
        this.filterEndpoint = this.datatablesContainer.dataset.endpointFiltershow;
        //this.fetchFilterAction(this.createFilterAction);
    }

    fetchFilterAction = doing => {
        $.ajax({
            url: this.filterEndpoint,
            type: 'POST',
            dataType: 'json',
            success: res => {
                doing(res);
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                console.error(`${errorThrown}`);
                console.error(`${textStatus}`);
            }
        });
    }


    createFilterAction = filterObject => {
        filterObject.forEach(object => {
            let filter = document.querySelector(`#filter-${object.target}`),
                container = filter.querySelector('.qm-filter__dropdown__content'),
                inputType = this.filterInputType(object.target),
                newInputOptions = [];

            container.innerHTML = '';

            object.items.forEach(item => {
                let filterTemplate = `
                    <div class="new main-dropdown qm-form-group qm-form-group--${(inputType === 'checkbox') ? 'check' : 'radio'} ${item.status}">
                        <label for="${object.target + '-' + item.title}" class="main-label" tabindex="0">
                            <input
                                ${item.status}
                                type="${inputType}"
                                name="${object.target}"
                                id="${object.target}-${item.title}"
                                class="main-filter ${object.target} ${item.status}"
                                value="${item.title}"
                                data-type="${object.target}"
                                tabindex="0" />

                            <span class="icon"></span>
                            <span class="text-content">${item.title}</span>
                        </label>
                    </div>
                `;
                container.innerHTML += filterTemplate;
            })
        })

        //this.addToggler();
    }

    filterInputType = filter => {
        let inputType;
        switch (filter) {
            case 'year':
                inputType = 'radio';
                break;
            case 'quarter':
            case 'evu':
            case 'region':
            case 'product_type':
            case 'lines':
            case 'complexity':
                inputType = 'checkbox';
                break;
        }

        return inputType;
    }


    updateFilterAction = () => {

    }


    removeFilterAction = () => {

    }


    addToggler() {
        let dropdown = document.querySelectorAll('.qm-filter__dropdown__content')
        Array.from(dropdown).forEach((item) => {
            if (item.querySelector('.selectToggle') === null) {
                let container = document.createElement("div");
                container.classList.add('selectToggle')
                container.classList.add('selectToggle')
                item.prepend(container)
            } else {
                item.querySelector('.selectToggle').remove()
                let container = document.createElement("div");
                container.classList.add('selectToggle')
                container.classList.add('selectToggle')
                item.prepend(container)
            }

            let inputs = item.querySelectorAll('.main-dropdown input'),
                checked = false,
                region = false;
            Array.from(inputs).forEach((input) => {
                checked = (input.checked)
                region = (input.getAttribute('name') === 'region')
            })

            if (checked) {
                item.querySelector('.selectToggle').innerHTML = (region) ? 'Region auswählen' : 'Alle abwählen'
                item.querySelector('.selectToggle').classList.add('active')
            } else {
                item.querySelector('.selectToggle').innerHTML = (region) ? 'NRW' : 'Alle auswählen'
                item.querySelector('.selectToggle').classList.remove('active')
            }
        })

        this.toggleAll()
    }

    toggleAll() {
        let dropdown = document.querySelectorAll('.qm-filter__dropdown__content')
        Array.from(dropdown).forEach((item) => {
            let inputs = item.querySelectorAll('.main-dropdown.available input');
            let region = false;
            item.querySelector('.selectToggle').addEventListener('click', function() {
                if (this.classList.contains('active')) {
                    Array.from(inputs).forEach((input, i) => {
                        if (i == (inputs.length - 1)) {
                            input.click()
                        }
                        input.checked = false
                        region = (input.getAttribute('name') === 'region')
                    })
                    this.innerHTML = (region) ? 'NRW' : 'Alle auswählen'
                    this.classList.remove('active')
                } else {
                    Array.from(inputs).forEach((input, i) => {
                        if (i == (inputs.length - 1)) {
                            input.click()
                        }
                        input.checked = true
                        region = (input.getAttribute('name') === 'region')
                    })
                    this.innerHTML = (region) ? 'Region auswählen' : 'Alle abwählen'
                    this.classList.add('active')
                }
            })
        })
    }

    rewriteComplexity() {
        let complexity = document.querySelector('#filter-complexity');
        Array.from(complexity.querySelectorAll('label')).forEach(function(label) {
            let currentText = label.querySelector('.text-content');
            let status;

            if (currentText.textContent == '1') {
                status = 'Einfach'
            } else if (currentText.textContent == '2') {
                status = 'Normal'
            } else if (currentText.textContent == '3') {
                status = 'Anspruchsvoll'
            }

            currentText.innerHTML = status
        })
    }



}
